import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

import { useMemo } from "react";

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

import { RFQChatHistory } from "../../../../Components/ChatBox/RFQChatBox";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField, ComboboxField3 } from "../../../../Components/formElements/ComboboxField";
// import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";
import PageLevelRiverseTimer from "../../../../Components/PageLevelRiverseTimer";
import DataTable from "react-data-table-component";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  formatDate,
  formatDateTime,
  validateRequired,
} from "../../../../common/Validations";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import moment from "moment";
import ShowHorizontalStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowHorizontalStatus";
import Loader from "../../../../Components/Loader";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import { getRfqQuotation } from "../../../../redux/feature/supplier_app/sourcingSlice";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import ExtendClosingTimeModal from "./ExtendClosingTimeModal";
import ManageSuppliersModal from "./ManageSuppliersModal";

const formatDisplayValue = (val) => {
  if (!val) return "";
  if (typeof val === "string") return val;
  if (Array.isArray(val)) {
    return val
      .map((item) =>
        typeof item === "object" && item !== null
          ? item.name || item.description || item.code || ""
          : String(item)
      )
      .filter(Boolean)
      .join(", ");
  }
  if (typeof val === "object") {
    return val.name || val.description || val.code || "";
  }
  return String(val);
};

// ComboboxField's getvalue default is a fresh arrow each render, so passing an
// inline (or omitting) it makes its effect loop. A module-level constant keeps
// the reference stable. Defined here and passed as a NOOP on the read-only
// ComboboxFields in RenderInputField below.
const NOOP = () => {};

// Questionnaire answer field rendered per question (READ-ONLY display).
// Declared at MODULE level so its type reference is stable (a component defined
// inside the parent is a NEW type each render, which makes React remount every
// input and reset dropdowns/lose focus). Values come from the submitted payload
// stored on each question object as `questionData.answer`.
// Criteria / weightage / attachment also come off the same question object
// (`criteria`, `weightage`, `attachment`) and are shown read-only. Older RFQs
// (or questions saved before these fields existed) simply omit them, so each is
// rendered only when its data is present.
const RenderInputField = ({ questionData, onViewAttachment }) => {
  const {
    componentId,
    mandatory,
    question,
    answerDefinition,
    serialNo,
    criteria,
    weightage,
  } = questionData;
  const answerValue = questionData?.answer;
  const attachmentValue = questionData?.attachment;

  // The question's answer input (read-only). Kept as a helper so the criteria/
  // weightage and attachment blocks can be appended after it in the shared Row.
  const renderAnswer = () => {
    switch (answerDefinition?.type) {
      case "textarea":
        return (
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <TextAreaField
              label={serialNo + ". " + question?.label}
              id={componentId}
              name={componentId}
              className="inputBox"
              placeholder=""
              value={answerValue || ""}
              disabled
              required={mandatory}
            />
          </Col>
        );
      case "select": {
        // Match the stored answer back to its option so the ComboboxField can
        // display the selected label (it renders value via the option object).
        const selectedOption =
          (answerDefinition?.options || []).find(
            (o) =>
              o?.name === answerValue ||
              o?.value === answerValue ||
              String(o?.id) === String(answerValue),
          ) || null;
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <ComboboxField
              label={serialNo + ". " + question?.label}
              placeholder=""
              data={answerDefinition?.options}
              id={componentId}
              iconClassName="dropdownIcon"
              name={componentId}
              code={componentId}
              description="name"
              setValue={selectedOption}
              disabled
              required={mandatory}
              // getvalue must be a STABLE reference: ComboboxField's getvalue
              // default is a fresh arrow each render, so omitting it (or passing
              // an inline one) makes its effect loop. Pass the stable NOOP.
              getvalue={NOOP}
            />
          </Col>
        );
      }
      case "radio":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>

            {answerDefinition?.options.map((option, index) => {
              const optVal = option?.value ?? option?.name ?? "";
              return (
                <div key={index} className="block">
                  <input
                    type="radio"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    value={optVal}
                    checked={answerValue === optVal}
                    disabled
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value} </span>
                </div>
              );
            })}
          </Col>
        );
      case "checkbox":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>

            {answerDefinition?.options.map((option, index) => {
              const optVal = option?.value ?? option?.name ?? "";
              const isChecked =
                Array.isArray(answerValue) && answerValue.includes(optVal);
              return (
                <div key={index} className="block">
                  <input
                    type="checkbox"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    value={optVal}
                    checked={isChecked}
                    disabled
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value} </span>
                </div>
              );
            })}
          </Col>
        );
      case "text":
        return (
          <Col
            xs={12}
            md={6}
            lg={6}
            className="commTopButtonRightLeftPadding block"
          >
            <InputField
              label={serialNo + ". " + question?.label}
              type="text"
              className="inputBox"
              id={componentId}
              name={componentId}
              placeholder=""
              value={answerValue || ""}
              disabled
              required={mandatory}
            />
          </Col>
        );
      case "number":
        return (
          <Col
            xs={12}
            md={6}
            lg={6}
            className="commTopButtonRightLeftPadding block"
          >
            <InputField
              label={serialNo + ". " + question?.label}
              type="number"
              className="inputBox"
              id={componentId}
              name={componentId}
              placeholder=""
              value={answerValue || ""}
              disabled
              required={mandatory}
            />
          </Col>
        );
      default:
        return null;
    }
  };

  // Read-only Criteria + Weightage. Always shown so the Commercial and Technical
  // questionnaire blocks render identically. Questions built with the form builder
  // carry `criteria`/`weightage`; questions from older RFQs (or templates saved
  // before these fields existed) omit them, so we fall back to the SAME defaults
  // the builder uses — "Weighted" criteria and 0 weightage — instead of hiding
  // the fields.
  const hasCriteria =
    criteria !== undefined && criteria !== null && criteria !== "";
  const hasWeightage =
    weightage !== undefined && weightage !== null && weightage !== "";
  const renderCriteriaWeightage = () => {
    return (
      <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
        <Row>
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <InputField
              label="Criteria"
              className="inputBox"
              value={hasCriteria ? criteria : "Weighted"}
              disabled
            />
          </Col>
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <InputField
              label="Weightage"
              type="number"
              className="inputBox"
              value={hasWeightage ? weightage : 0}
              disabled
            />
          </Col>
        </Row>
      </Col>
    );
  };

  // Read-only attachment viewer. Rendered only when an attachment id exists.
  const renderAttachment = () => {
    if (!attachmentValue) return null;
    return (
      <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding">
        <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
          Attachment
        </label>
        <img
          src="assets/img/newIcons/attached-file.png"
          className="mt-1 attachmentIcon"
          alt="attachments"
          style={{ cursor: "pointer" }}
          onClick={() => onViewAttachment && onViewAttachment(attachmentValue)}
        />
      </Col>
    );
  };

  const answerField = renderAnswer();
  // Unknown answer type → render nothing (and no orphan criteria/attachment).
  if (!answerField) return null;

  return (
    <React.Fragment>
      {answerField}
      {renderCriteriaWeightage()}
      {renderAttachment()}
    </React.Fragment>
  );
};

// Ordered wizard steps for the details page. The header tabs, tab panels and
// the Previous / Next buttons all key off this single list so the order stays
// in sync. The Commercial / Technical questionnaires share a single
// "Tech & Comm Template" tab (same as the Create RFQ tabs page).
const tabList = [
  { id: "rfq-title", label: "RFQ Title" },
  { id: "configuration", label: "Configuration" },
  { id: "suppliers", label: "Suppliers" },
  { id: "line-items", label: "Line Items" },
  { id: "tech-comm", label: "Tech & Comm Template" },
  { id: "single-source", label: "Single Source" },
  { id: "chat-history", label: "Chat History" },
  { id: "schedule", label: "Schedule" },
];

const BuyerRFQDetails = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Request for Quotation");

  let rfxNr = useSelector((state) => state?.sourcing?.rfq?.rfxNr); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.workflow); // config Details from Store
  let sourcingConfig = useSelector((state) => state?.common?.data?.sourcing); // Common Details from Store

  // let dropdownOption = [
  //   {
  //     id: "1",
  //     name: "Sample Data 1",
  //   },
  //   {
  //     id: "2",
  //     name: "Sample Data 2",
  //   },
  // ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [getTechnicalUserList, setTechnicalUserList] = useState([]);
  const [getDropdownData, setDropdownData] = useState("");

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisibleCS, setCardVisibleCS] = useState(true);
  const [activeTab, setActiveTab] = useState("rfq-title");

  const [finalTimerValue, setFinalTimerValue] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Extend Time Modal
  const [showExtendModal, setShowExtendModal] = useState(false);

  // Manage Suppliers Modal
  const [showManageSuppliers, setShowManageSuppliers] = useState(false);

  const modalDataTeach = {
    title: "Tech Open",
    successMsg: "",
  };
  const modalDataComm = {
    title: "Commerial Open",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalDataTeach);

  const [formInputs, setFormInputs] = useState({
    rfxType: "",
    productType: "",
    rfxValue: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    buyerResponsible: "",
    companyAddress: "",
    rfxVersion: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    billingAddressCodeDesc: "",
    createdOn: "",
    buyerConact: "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCategoryCode: "",
    rfxCategoryDesc: "",
    rfqCreation: "",
    rfxTitle: "",
    openingdate: "",
    openingtime: "",
    closingdate: "",
    closingtime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    items: "",
    formCOMM: "",
    formTECH: "",
    termsConditions: [],
    supplierList: [],
    othersCharge: [],

    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
    rfxTechFocalPersonIdCode: "",
  });

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibilityCS = () => {
    setCardVisibleCS(!isCardVisibleCS);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "VAT Code % ",
      selector: (row) => row.taxCode || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => formatDate(row.deliveryDate) || "--",
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      width: "120px",
    },
  ];

  const suppliersColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
        // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.AssociateNumber || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },

    {
      name: "Name",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP Number",
      selector: (row) => row.sapAssociateNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: "Contact Number",
      selector: (row) => row.contactNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "EMail",
      selector: (row) => row.email,
      sortable: true,
      width: "250px",
    },
    {
      name: "RFX Status",
      selector: (row) => row.rfxSupplierStatus,
      cell: (row) => (
        <>
          {row.rfxSupplierStatus === "Acknowledged" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.rfxSupplierStatus}
            </span>
          ) : row.rfxSupplierStatus === "Regret" ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.rfxSupplierStatus}
            </span>
          ) : (
            row.rfxSupplierStatus || "--"
          )}
        </>
      ),
      width: "170px",
      sortable: true,
    },
    {
      name: "Supplier Status",
      cell: (row) => (
        <>
          {row.qtnSupplierStatus === "QTN Received" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.qtnSupplierStatus}
            </span>
          ) : (
            "--"
          )}
        </>
      ),
      selector: (row) => row.qtnSupplierStatus,
      sortable: true,
      width: "150px",
    },
    {
      name: "Quotation Number",
      cell: (row) => (
        <>
          {row.qtnSupplierStatus === "QTN Received" ? (
            <button className="btnInfo">{row.quotationNr}</button>
          ) : (
            "--"
          )}
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Quotation Version",
      selector: (row) => row.qtnVersion || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Category",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
          // onClick={() => categoryItemShowModal(row.vendorCategory)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.vendorCategory?.length || 0}{" "}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Company Code",
      cell: (row) => (
        <>
          <span> {row.companyCode} </span>
        </>
      ),
      width: "150px",
    },
  ];

  const loadInitialPageData = async () => {
    if (rfxNr) {
      let obj = {
        documentNumber: rfxNr,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getRfxDocumentDetail(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setFormInputs(item.data);
          // console.log(">> FORM DEBUG keys", Object.keys(item?.data || {}));
          // console.log(">> FORM DEBUG formCOMM", item?.data?.formCOMM);
          // console.log(">> FORM DEBUG formTECH", item?.data?.formTECH);
          // console.log(
          //   ">> FORM DEBUG any answer?",
          //   (item?.data?.formCOMM || []).find((q) => q?.answer),
          //   (item?.data?.formTECH || []).find((q) => q?.answer),
          // );
          setData(item?.data?.items);

          updateTimerValue(item?.data?.closingDateTime);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      setLoading(false);
    } else {
      window.history.back();
    }
  };

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // Show Item level data
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">> Check data", getDropdownData);
    if (getDropdownData?.name) {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const loadTechUser = async () => {
    let obj = {
      roleId: "TECHNICAL",
    };
    await ItemService.getTechnicalUser(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setTechnicalUserList(item?.data);
      } else {
        setTechnicalUserList([]);
        console.log(">> Error: Loading loadTechUser");
      }
    });
  };

  useEffect(() => {
    loadInitialPageData();
    loadTechUser();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxNr]);

  const updateTimerValue = (closingDateTime) => {
    let timerData = {};
    const openingMoment = moment(); // This is the current date-time
    const closingMoment = moment(closingDateTime, "YYYY-MM-DD HH:mm");
    const diffInMilliseconds = closingMoment.diff(openingMoment);
    const duration = moment.duration(diffInMilliseconds);

    // If the time is already past, return 0 and set timeExpired flag
    if (diffInMilliseconds <= 0) {
      setFinalTimerValue({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
    } else {
      // Extract days, hours, minutes, and seconds correctly
      timerData.days = Math.floor(duration.asDays()) || 0;
      timerData.hours = duration.hours() || 0; // Remaining hours after days
      timerData.minutes = duration.minutes() || 0; // Remaining minutes after hours
      timerData.seconds = duration.seconds() || 0; // Remaining seconds after minutes
      setFinalTimerValue(timerData);
    }
  };

  // Extend Time handlers
  const handleOpenExtendModal = () => {
    setShowExtendModal(true);
  };

  const handleTextChange = (data) => {
    // console.log(">> data", data);
  };

  const [getTechOpenDisabled, setTechOpenDisabled] = useState(false);
  const handleTechOpen = async () => {
    let requiredFields = [];

    if (!validateRequired(formInputs?.rfxTechFocalPersonIdCode)) {
      requiredFields.push("*Please select the Tech Focal Point");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    // First close the timer by setting closingDateTime to now
    const toastId = toast.loading("Closing timer...", {
      position: "top-right",
    });
    try {
      const now = moment();
      const closePayload = {
        businessComponentInstanceId: formInputs?.rfxNr,
        closingDateTime: now.format("YYYY-MM-DD HH:mm"),
        totalHour:
          Math.round(
            now.diff(
              moment(formInputs.openingDateTime, "YYYY-MM-DD HH:mm"),
              "hours",
              true,
            ) * 100,
          ) / 100,
      };
      await ItemService.updateRfx(closePayload);
    } catch (err) {
      // proceed even if close timer fails
    }
    toast.dismiss(toastId);

    let obj = {
      rfxNr: formInputs.rfxNr,
      techUserId: formInputs?.rfxTechFocalPersonIdCode,
    };
    setTechOpenDisabled(true);
    await ItemService.rfxTechOpen(obj).then((item) => {
      if (item?.status === 200) {
        modalDataTeach.successMsg = item?.message;
        setModalInfo(modalDataTeach);
        onSuccessfullyRegistered();
        dispatch(getRfqQuotation({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTechOpenDisabled(false);
  };

  const handleCommOpen = async () => {
    // let requiredFields = [];

    // if (!validateRequired(formInputs?.rfxTechFocalPersonIdCode)) {
    //   requiredFields.push("*Please select the Tech Focal Point");
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    let obj = {
      rfxNr: formInputs.rfxNr,
      commUserId: "", // Add user in future
    };
    setTechOpenDisabled(false);
    await ItemService.rfxCommOpen(obj).then((item) => {
      // console.log(">> item! ", item);
      if (item?.status === 200) {
        modalDataComm.successMsg = item?.message;
        setModalInfo(modalDataComm);
        onSuccessfullyRegistered();
        dispatch(getRfqQuotation({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTechOpenDisabled(true);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const suppliers = useMemo(
    () => formInputs.supplierList || [],
    [formInputs.supplierList]
  );

  // Sum of each questionnaire block's weightage, shown in the block header the
  // same way CreateRFQTabs.js does. Reads the saved question objects; questions
  // without a weightage contribute 0.
  const commercialWeightSum = (formInputs.formCOMM || []).reduce(
    (sum, q) => sum + (Number(q?.weightage) || 0),
    0,
  );
  const technicalWeightSum = (formInputs.formTECH || []).reduce(
    (sum, q) => sum + (Number(q?.weightage) || 0),
    0,
  );

  // Wizard navigation helpers. Current index is derived from the active tab so
  // Previous / Next can be shown conditionally below the tabs.
  const currentTabIndex = tabList.findIndex((tab) => tab.id === activeTab);
  const isLastTab = currentTabIndex === tabList.length - 1;
  const goToPreviousTab = () => {
    if (currentTabIndex > 0) setActiveTab(tabList[currentTabIndex - 1].id);
  };
  const goToNextTab = () => {
    if (currentTabIndex < tabList.length - 1)
      setActiveTab(tabList[currentTabIndex + 1].id);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <Loader isLoading={loading} className={"text-center"} />
        </Col>
        {!loading && (
          <Col xs={12} md={12} className="rightSide">
            <div className="rightSideInner PageCommonCSS">
              <h2 className="mainTitle">
                Buyer RFQ:{" "}
                <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                  {formInputs?.rfxNr}
                </span>
                <span>
                  {formInputs?.rfxHeaderStatus === "Published" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "QTN Received" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Cancelled" ? (
                    <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "RFQ Created" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Acknowledged" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Tech Approved" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Technical Open" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Commercial Open" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Commercial Approved" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus ===
                    "Commercial Pending with L1" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus ===
                    "Commercial Pending with L2" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : (
                    formInputs?.rfxHeaderStatus
                  )}
                </span>
              </h2>
              <p className="subText">Buyer RFQ Details</p>
              <hr />

              {config?.showInDetailPage &&
                formInputs?.workflowActionLogs?.length > 0 && (
                  <ShowHorizontalStatus
                    rowdatamodal={formInputs?.workflowActionLogs}
                  />
                )}

              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={12} md={5} lg={5} className="">
                        <p className="headerTitle fs-4">
                          Remaining Time for submission
                        </p>
                      </Col>
                      <Col xs={12} md={7} lg={7} className="flex justify-end">
                        <img
                          src="assets/img/stopwatch.png"
                          alt="stopwatch"
                          style={{ width: "60px", height: "58px" }}
                          className="mr-6 mt-1"
                        />
                        {formInputs?.rfxHeaderStatus === "Published" ||
                          formInputs?.rfxHeaderStatus === "QTN Received" ||
                          formInputs?.rfxHeaderStatus === "Technical Open" ? (
                          <PageLevelRiverseTimer timerData={finalTimerValue} />
                        ) : (
                          <PageLevelRiverseTimer timerData={0} />
                        )}
                      </Col>
                    </Row>
                  </h2>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {tabList.map((tab) => {
                      const isActive = activeTab === tab.id;
                      return (
                        <li className="nav-item" role="presentation" key={tab.id}>
                          <button
                            className={`nav-link ${isActive ? "active" : ""}`}
                            id={`${tab.id}-tab`}
                            type="button"
                            role="tab"
                            aria-controls={tab.id}
                            aria-selected={isActive ? "true" : "false"}
                            onClick={() => setActiveTab(tab.id)}
                          >
                            {tab.label}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                  <div className="tab-content pt-2" id="myTabContent">
                    <div
                      className={`tab-pane fade ${
                        activeTab === "rfq-title" ? "show active" : ""
                      }`}
                      id="rfq-title"
                      role="tabpanel"
                      aria-labelledby="rfq-title-tab"
                    >
              {/*RFQ Type  */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RT</span>
                      </Col>
                      <Col xs={12} md={4} lg={4}>
                        <span className="headerTitle">RFQ Type </span>
                        <span className="subHeaderTitle">
                          RFQ Type Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Category"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxCategoryDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Type"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Header User id"
                            name="UnitPrice"
                            // placeholder=""
                            // value={PriceSheduleModuledata.UnitPrice || ""}

                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Number Of Evaluation"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxNoOfEvaluationTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Product Type"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.productTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField3
                            label="Tech Focal Point"
                            placeholder=""
                            data={getTechnicalUserList}
                            id="rfxTechFocalPersonId"
                            name="rfxTechFocalPersonId"
                            code="rfxTechFocalPersonIdCode"
                            description="rfxTechFocalPersonIdDesc"
                            iconClassName="dropdownIcon"
                            setValue={formInputs?.rfxTechFocalPersonId || ""}
                            getvalue={setDropdownData}
                            // className="dropdownOption"
                            disabled={
                              formInputs.rfxHeaderStatus === "Tech Approved"
                                ? true
                                : false
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/*RFQ Type  */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RH</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">RFQ Header </span>
                        <span className="subHeaderTitle">
                          RFQ Header Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ ID"
                            name="rfxNr"
                            // placeholder=""
                            value={formInputs?.rfxNr || ""}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Currency"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxCurrencyCode || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Contact"
                            name="buyerConact"
                            // placeholder=""
                            value={formInputs?.buyerConact || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Responsible"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.initiatorName || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Version"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.rfxVersion || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Billing Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.billingAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Company Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.companyAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.companyAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          lg={1}
                          className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                        >
                          <div className="d-flex flex-column ">
                            <p className="fw-medium m-0 text-nowrap">
                              Instructions Attachment
                            </p>

                            {(formInputs?.instructionsAttachment && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(
                                    formInputs?.instructionsAttachment,
                                  )
                                }
                              />
                            )) ||
                              "--"}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "configuration" ? "show active" : ""
                      }`}
                      id="configuration"
                      role="tabpanel"
                      aria-labelledby="configuration-tab"
                    >
              {/*Header Info */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">HI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Header Info</span>
                        <span className="subHeaderTitle">
                          RFQ Header Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Title"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxTitle || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxDescription || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.incoTermsLocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms Location"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.incoTermsLocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Payment Terms"
                            name="firstName"
                            placeholder=""
                            // value={"400000 - Vasanthraman"}
                            value={formatDisplayValue(
                              formInputs?.paymentTerms ||
                                formInputs?.paymentTermsCode
                            )}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Other Currencies"
                            name="firstName"
                            placeholder=""
                            // value={formInputs?.otherCurrencies}
                            value={formatDisplayValue(
                              formInputs?.otherCurrencies
                            )}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Milestone Payments"
                            name="firstName"
                            placeholder=""
                            // value={"400000 - Vasanthraman"}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Instruction Attachments"
                            name="firstName"
                            placeholder=""
                            // value={"400000 - Vasanthraman"}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col> */}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Instructions 10*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible10
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility10}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RE</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Instructions</span>
                        <span className="subHeaderTitle">
                          Instructions Section
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="p-4">
                        <Col xs={12} md={12} lg={12}>
                          {formInputs?.instructions && (
                            <RichTextEditor
                              value={formInputs?.instructions}
                              readOnly={true}
                              onChange={handleTextChange}
                            />
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Documents */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility4}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TD</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Documents</span>
                        <span className="subHeaderTitle">Documents Form</span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <h5 className="card-title"> Terms & Conditions</h5>
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={12}
                          lg={8}
                          className="commTopButtonRightLeftPadding"
                        >
                          {formInputs?.termsConditions?.map((item, i) => (
                            <div className="form-check" key={item.id}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`gridCheck${item.id}`}
                                checked={item.status}
                              // onChange={() =>
                              //   handleTermsConditionCheckBox(item.id)
                              // }
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`gridCheck${item.id}`}
                              >
                                {item.name}
                              </label>
                            </div>
                          ))}
                        </Col>
                        {/* <Col xs={12} md={12} lg={3}>
                          <ComboboxField
                            label="Acceptance To Terms & Conditions"
                            placeholder=""
                            data={dropdownOption}
                            id=""
                            iconClassName="dropdownIcon"
                            name=""
                            // setValue={formInputs.INCOTermslocation || ""}
                            disabled={true}
                            // getvalue={setDropdownData}
                          />
                        </Col> */}
                        <Row>
                          <h1 className="card-title">Documents :</h1>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.1. SCOPE OF WORK</p>
                            {(formInputs?.scopeOfwork && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.scopeOfwork)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.2. DRAWING</p>
                            {(formInputs?.drawing && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.drawing)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.3. ANNEXURES</p>
                            {(formInputs?.annexures && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.annexures)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.4. OTHERS</p>
                            {(formInputs?.others && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.others)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                        </Row>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/*charges selection*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisibleCS
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibilityCS}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CS</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Charges Selection</span>
                        <span className="subHeaderTitle">
                          Charges Selection
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisibleCS ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <h5 className="card-title commTopButtonRightLeftPadding">
                          Select Charges
                        </h5>
                        <Row>
                          <Col
                            xs={12}
                            md={12}
                            lg={8}
                            className="commTopButtonRightLeftPadding"
                          >
                            {formInputs?.othersCharge?.map((charge) => (
                              <div className="form-check" key={charge.id}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`charge-${charge.id}`}
                                  checked={formInputs?.othersCharge?.some(
                                    (item) => item.id === charge.id,
                                  )}
                                // onChange={() => handleChargeToggle(charge)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`charge-${charge.id}`}
                                >
                                  {charge.name}
                                </label>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "suppliers" ? "show active" : ""
                      }`}
                      id="suppliers"
                      role="tabpanel"
                      aria-labelledby="suppliers-tab"
                    >
              {/* 5 */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility5}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">SD</span>
                      </Col>
                      <Col xs={12} md={6} lg={7}>
                        <span className="headerTitle">Suppliers</span>
                        <span className="subHeaderTitle">
                          Selected Suppliers Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                      }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={suppliersColumns}
                            data={formInputs?.supplierList}
                            // progressPending={loading}
                            // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                            // pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "line-items" ? "show active" : ""
                      }`}
                      id="line-items"
                      role="tabpanel"
                      aria-labelledby="line-items-tab"
                    >
              {/* 6 */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility6}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>
                      <Col xs={12} md={6} lg={7}>
                        <span className="headerTitle">Line Items</span>
                        <span className="subHeaderTitle">
                          Material/ Service Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""
                      }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={PRLineItemInitialCol}
                            data={data}
                            // progressPending={loading}
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            pagination
                            // pagination={false}
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "tech-comm" ? "show active" : ""
                      }`}
                      id="tech-comm"
                      role="tabpanel"
                      aria-labelledby="tech-comm-tab"
                    >
              {/* Form: COMMERCIAL / TECHNICAL questionnaires - Tech & Comm
                  Template tab (same as the Create RFQ tabs page) */}
              {/* COMM - Spares & Operation Maintenance 08*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility8}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">OC</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">
                          Form: COMMERCIAL - Questionnaire
                        </span>
                        <span className="subHeaderTitle">
                          Total Weightage: {commercialWeightSum} /{" "}
                          {formInputs.commercialTotalWeigtage || 0}
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="commTopButtonRightLeftPadding">
                        {formInputs?.formCOMM?.length > 0 &&
                          formInputs?.formCOMM.map((formJsonData, index) => {
                            return (
                              <RenderInputField
                                questionData={formJsonData}
                                onViewAttachment={handleViewFile}
                                key={index}
                              />
                            );
                          })}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Form :TECH - Spares & Operation Maintenance09*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible9
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility9}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TS</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">
                          Form : TECHNICAL - Questionnaire
                        </span>
                        <span className="subHeaderTitle">
                          Total Weightage: {technicalWeightSum} /{" "}
                          {formInputs.technicalTotalWeight || 0} (Min:{" "}
                          {formInputs.minimumTechnicalTotalWeight || 0})
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible9 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="commTopButtonRightLeftPadding">
                        {formInputs?.formTECH?.length > 0 &&
                          formInputs?.formTECH.map((formJsonData, index) => {
                            return (
                              <RenderInputField
                                questionData={formJsonData}
                                onViewAttachment={handleViewFile}
                                key={index}
                              />
                            );
                          })}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "single-source" ? "show active" : ""
                      }`}
                      id="single-source"
                      role="tabpanel"
                      aria-labelledby="single-source-tab"
                    >
              {/* Single Source Justification*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility8}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">OC</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">
                          Single Source Justification
                        </span>
                        {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                      </Col>

                      <Col xs={1} md={1} lg={1} className="">
                        {/* <SourcingCommonFilter /> */}
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      {/* Form: INTRO-Spares & Operations Maintenance */}
                      <Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Single Source Justification"
                            name=""
                            // placeholder=""
                            // value={PriceSheduleModuledata.UnitPrice || ""}
                            onChange={onInputChange}
                          // disabled={getInputFields}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "chat-history" ? "show active" : ""
                      }`}
                      id="chat-history"
                      role="tabpanel"
                      aria-labelledby="chat-history-tab"
                    >
              {/* ----- Chat History Section ----- */}
              <div className="accordion mb-4" id="chatHistoryAccordion">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className="bi bi-chat-dots fs-4"></i>
                      </Col>
                      <Col xs={12} md={11} lg={11}>
                        <span className="headerTitle">Chat History</span>
                        <span className="subHeaderTitle">All conversations with suppliers</span>
                        {/* <RFQChatHistory
                          key={`chat-${formInputs.rfxNr}`}
                          rfxId={formInputs.rfxNr}
                          // suppliers={formInputs.supplierList || []}
                          suppliers={suppliers}
                        /> */}
                      </Col>
                    </Row>
                  </h2>
                  <div className="accordion-collapse collapse show visible">
                    <div className="accordion-body">
                      <RFQChatHistory
                        key={`chat-${formInputs._id}`}
                        rfxId={formInputs._id}
                        // suppliers={formInputs.supplierList || []}
                        suppliers={suppliers}
                      />
                    </div>
                  </div>
                </div>
              </div>

                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "schedule" ? "show active" : ""
                      }`}
                      id="schedule"
                      role="tabpanel"
                      aria-labelledby="schedule-tab"
                    >
              {/* Schedule - Opening / Closing dates (moved from the
                  Header Info accordion, same as the Create RFQ Schedule tab) */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">HI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Header Info</span>
                        <span className="subHeaderTitle">
                          RFQ Header Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Opening Date"
                            name="UnitPrice"
                            // placeholder=""
                            value={
                              formatDateTime(formInputs?.openingDateTime) || ""
                            }
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Closing Date"
                            name="UnitPrice"
                            // placeholder=""
                            value={
                              formatDateTime(formInputs?.closingDateTime) || ""
                            }
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="pageFooter mb-4 pb-2">
                <Row className="align-items-center">
                  <Col xs={12} md={3} lg={3} className="mb-2">
                    {currentTabIndex > 0 && (
                      <button
                        type="button"
                        className="btnTable"
                        onClick={goToPreviousTab}
                      >
                        <i className="bi bi-arrow-left me-2"></i> Previous
                      </button>
                    )}
                  </Col>
                  <Col xs={12} md={3} lg={3} className="mb-2 ms-auto text-end">
                    {!isLastTab && (
                      <button
                        type="button"
                        className="btnTable"
                        onClick={goToNextTab}
                      >
                        Next <i className="bi bi-arrow-right ms-2"></i>
                      </button>
                    )}
                  </Col>
                </Row>
              </div>

              <div className="pageFooter">
                <Row className="rowDirection pb-4">
                  {/* {sourcingConfig?.RFX?.pageBtn?.preClose &&
                    (formInputs?.rfxHeaderStatus === "Published" ||
                      formInputs?.rfxHeaderStatus === "QTN Received") && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          //  onClick={handleModify}
                        >
                          Pre Close
                        </button>
                      </Col>
                    )} */}

                  {/* {sourcingConfig?.RFX?.pageBtn?.rFQCancel &&
                    (formInputs?.rfxHeaderStatus === "Published" ||
                      formInputs?.rfxHeaderStatus === "Technical Open") && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          //  onClick={handleModify}
                        >
                          RFQ Cancel
                        </button>
                      </Col>
                    )} */}

                  {formInputs?.rfxTypeCode === "10" && sourcingConfig?.RFX?.pageBtn?.techOpen &&
                    formInputs?.rfxHeaderStatus === "QTN Received" && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          onClick={handleTechOpen}
                          disabled={getTechOpenDisabled}
                        >
                          Tech Open
                        </button>
                      </Col>
                    )}
                  {formInputs?.rfxTypeCode === "20" && sourcingConfig?.RFX?.pageBtn?.techOpen &&
                    formInputs?.rfxHeaderStatus === "QTN Received" && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          onClick={handleCommOpen}
                          disabled={getTechOpenDisabled}
                        >
                          Comm Open
                        </button>
                      </Col>
                    )}

                  {formInputs?.workflowTECHActionLogs?.length > 0 &&
                    sourcingConfig?.RFX?.pageBtn?.commOpen &&
                    (formInputs?.rfxHeaderStatus === "QTN Received" ||
                      formInputs?.rfxHeaderStatus === "Tech Approved") && (
                      <Col xs={12} md={2} lg={2} className="">
                        <button className="btnTable" onClick={handleCommOpen}>
                          Comm Open
                        </button>
                      </Col>
                    )}

                  {!formInputs?.workflowTECHActionLogs?.length > 0 && (
                    <>
                      <Col xs={12} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={() => setShowManageSuppliers(true)}
                        >
                          <i className="bi bi-people me-1"></i> Manage Suppliers
                        </button>
                      </Col>
                      <Col xs={12} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={handleOpenExtendModal}
                        >
                          <i className="bi bi-clock me-1"></i>
                          Update RFQ Timer
                        </button>
                      </Col>
                    </>
                  )}

                  {/* {sourcingConfig?.RFX?.pageBtn?.rFQModify &&
                    (formInputs?.rfxHeaderStatus === "Published" ||
                      formInputs?.rfxHeaderStatus === "QTN Received" ||
                      formInputs?.rfxHeaderStatus === "Tech Approved" ||
                      formInputs?.rfxHeaderStatus === "Technical Open") && (
                      <Col xs={12} md={2} lg={1} className="">
                        <button
                          className="btnTable"
                          //  onClick={handleModify}
                        >
                          RFQ Modify
                        </button>
                      </Col>
                    )} */}

                  {/* {sourcingConfig?.RFX?.pageBtn?.excelDownload && (
                    <Col xs={12} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        //  onClick={handleModify}
                      >
                        Excel Download
                      </button>
                    </Col>
                  )} */}
                </Row>
              </div>
            </div>
          </Col>
        )}
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      <ExtendClosingTimeModal
        show={showExtendModal}
        onHide={() => setShowExtendModal(false)}
        formInputs={formInputs}
        onSuccess={loadInitialPageData}
      />
      <ManageSuppliersModal
        show={showManageSuppliers}
        onHide={() => setShowManageSuppliers(false)}
        formInputs={formInputs}
        onSuccess={loadInitialPageData}
      />
    </main>
  );
};

export default BuyerRFQDetails;